import { makeSvgIcon } from "./svg-icon";
import svg from "./violin-plots-icon.svg?react";

export const ViolinPlotsIcon = makeSvgIcon(svg);

export default ViolinPlotsIcon;
